import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwitchSimple1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 19,
	viewBox: "0 0 36 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M35.15 2.42749H22.842L13.2691 16.4449H0.277344",
		stroke: "currentColor",
		strokeWidth: 4
	})
});
export default SvgSwitchSimple1;
